import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { BlockType, ResourceLibraryBlockConfigSchema } from './blockConfig/Types';

export const ResourceLibraryBlockSchema = BlockSchema.extend({
  blockConfig: ResourceLibraryBlockConfigSchema,
});

export type ResourceLibraryBlock = z.infer<typeof ResourceLibraryBlockSchema>;

export function isResourceLibraryBlock(block: Block): block is ResourceLibraryBlock {
  return block.blockConfig.type === BlockType.ResourceLibrary;
}
